module.exports = __webpack_public_path__ + "static/img/icon-ga.dec4700.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-ga.svg
// module id = CWkl
// module chunks = 1